import { animatePulse } from "@/src/utils/animation.utils";
import { useEffect, useRef } from "react";
import { Animated, View } from "react-native";

export const PostSkeleton = () => {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    animatePulse(opacity);
  }, []);

  return (
    <Animated.View style={{ opacity }}>
      <View className="bg-chalk rounded-xl p-4 gap-4 md:rounded-2xl md:border md:border-ash-3">
        <View className="flex-row items-center gap-3">
          <View className="h-10 w-10 rounded-full bg-ash-3" />
          <View className="gap-2 flex-1">
            <View className="h-3 w-1/4 rounded-md bg-ash-3" />
            <View className="h-3 w-1/6 rounded-md bg-ash-3" />
          </View>
        </View>

        <View className="gap-2">
          <View className="h-3 w-full rounded-md bg-ash-3" />
          <View className="h-3 w-11/12 rounded-md bg-ash-3" />
          <View className="h-3 w-4/6 rounded-md bg-ash-3" />
        </View>

        <View className="flex-row gap-4 pt-2">
          <View className="h-3 w-12 rounded-md bg-ash-3" />
          <View className="h-3 w-12 rounded-md bg-ash-3" />
          <View className="h-3 w-12 rounded-md bg-ash-3" />
        </View>
      </View>
    </Animated.View>
  );
};
